import React from "react";
import ProfileComponents from "../../components/profile-components";

const Profile = () => {
  return (
    <>
      <ProfileComponents />
    </>
  );
};

export default Profile;
